module.exports = __webpack_public_path__ + "WorkSans-Bold.766db6981a8f279ef14d.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Bold.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Bold.ttf
// module chunks = styles